import dayjs from "dayjs";
import { GlobalStoreContextType } from "../context/GlobalStoreContext";
import { EquipmentModel } from "./Equipment.model";
import { MapObject } from "./MapObject";

export class Equipment extends EquipmentModel {
    static fromFeature(feature: GeoJSON.Feature, project: any, timezone: string): Equipment {
        return Equipment.fromApiObject(
            {
                id: null,
                project_id: project.id,
            },
            timezone
        );
    }

    getMapObject(globalStoreContext: GlobalStoreContextType): MapObject | null {
        const projectMapObjects = globalStoreContext.mapObjectsForProject(this.projectId || "");
        const mapObject = projectMapObjects.find(
            (mapObject) => mapObject.mappableType == "Equipment" && mapObject.mappableId == this.id
        );

        if (mapObject) {
            return mapObject;
        }

        return null;
    }

    openOnDay(checkDate: dayjs.Dayjs): boolean {
        if (!checkDate) {
            return true;
        }

        if (this.openDate) {
            const openDate = this.openDate.subtract(this.openDate.utcOffset(), "minute");

            if (checkDate.isBefore(openDate)) {
                return false;
            }
        }
        if (this.closeDate) {
            const closeDate = this.closeDate.add(this.closeDate.utcOffset(), "minute");

            // If the checkDate is after the closeDate then that Area is not open.
            if (checkDate.isAfter(closeDate) || checkDate.isSame(closeDate, "day")) {
                return false;
            }
        }

        if (
            this.equipmentTempClosures?.some((exception) => {
                // Exception day start and end provided. Today is in the window provided
                if (
                    exception.closureStart &&
                    exception.closureEnd &&
                    checkDate.isBetween(exception.closureStart, exception.closureEnd, "day", "[]")
                ) {
                    return true;
                }
                // Temp closure provided start date but no end date. i.e. Closed until further notice.
                if (
                    (exception.closureStart &&
                        !exception.closureEnd &&
                        checkDate.isAfter(exception.closureStart, "day")) ||
                    checkDate.isSame(exception.closureStart, "day")
                ) {
                    return true;
                }
                // Temp closure provided end date but no start date. i.e. Closed until this date.
                if (
                    !exception.closureStart &&
                    exception.closureEnd &&
                    checkDate.isBefore(exception.closureEnd, "day")
                ) {
                    return true;
                }
            })
        ) {
            return false;
        }

        return true;
    }
}
